"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AppSwitcherService = void 0;
var app_1 = require("app");
var AppSwitcherService = /** @class */ (function () {
    function AppSwitcherService() {
        this.$appSwitcherSelector = ".header__menu__item--app__switcher";
        this.dataPropName = "app-items";
        this.FilterItems = function (items) {
            return (0, app_1.safe)(items).filter(function (item) {
                return item.link && item.countryLanguage;
            });
        };
        this.$appSwitcherElement = $(this.$appSwitcherSelector);
        var appItems = app_1.AttrService.data(this.$appSwitcherElement, this.dataPropName);
        this.data = this.FilterItems(appItems);
    }
    AppSwitcherService.prototype.GetData = function () {
        return this.data;
    };
    AppSwitcherService.prototype.HasItems = function () {
        return this.data.length > 1;
    };
    return AppSwitcherService;
}());
var appSwitcherService = new AppSwitcherService();
exports.AppSwitcherService = appSwitcherService;
